import React from "react"
import { Theme, Typography } from "@material-ui/core"
import { useTheme } from "@material-ui/styles"

interface IPickCardProps {
    value: string,
    isSelected: boolean,
    onSelected: (value: string) => void
}

export default function PickCard({ value, isSelected, onSelected }: IPickCardProps) {
    const theme = useTheme<Theme>()

    return (
        <div
            className={isSelected ? "card-pick card-pick-selected" : "card-pick"}
            onClick={() => onSelected(value)}
        >
            <Typography variant="body1" style={{ color: theme.palette.primary.dark }}>
                <b>{value}</b>
            </Typography>
        </div>
    )
}
